const getAdditionalCustomerById = (state, customerId) =>
  state.customer.additionalCustomers?.[customerId];

export default getAdditionalCustomerById;
